(() => {
  function init() {
    console.log("Vehicle Filter Section Loaded");
    const wrapper = document.querySelector(".section-vehicle-filter--wrapper");
    const select_by_make = document.getElementById("vehicle-makes");
    const select_by_model = document.getElementById("vehicle-models");
    const select_by_vehicle = document.getElementById("vehicle-identifiers");
    const confirmButton = document.querySelector(
      ".section-vehicle-filter--wrapper .confirm-button"
    );
    if (!wrapper || !select_by_make || !select_by_model || !select_by_vehicle) return;
    const models = [...select_by_model.options].slice(1);
    const vehicles = [...select_by_vehicle.options].slice(1);
    const reset = (select, options) => {
      const placeholder = select.options[0];
      select.replaceChildren(placeholder, ...options);
      select.selectedIndex = 0;
    };
    wrapper.querySelector('.njt-finder-clear')?.addEventListener('click', () => {
      select_by_make.selectedIndex = 0;
      reset(select_by_model, []);
      reset(select_by_vehicle, []);
      select_by_model.disabled = true;
      select_by_vehicle.disabled = true;
      confirmButton?.setAttribute('disabled', 'true');
      window.globalVehicleFilter?.clearFilter();
    });
    select_by_make.addEventListener('change', function () {
      confirmButton?.setAttribute('disabled', 'true');
      reset(select_by_model, models.filter(option => option.dataset.relativeMake === this.value));
      select_by_model.disabled = this.value === 'MAKE';
      reset(select_by_vehicle, []);
      select_by_vehicle.disabled = true;
    });
    select_by_model.addEventListener('change', function () {
      confirmButton?.setAttribute('disabled', 'true');
      reset(select_by_vehicle, vehicles.filter(option => option.dataset.relativeMake === select_by_make.value && option.dataset.relativeModel === this.value));
      select_by_vehicle.disabled = this.value === 'MODEL';
    });
    select_by_vehicle.addEventListener("change", function () {
      if (this.value === "VEHICLE") {
        confirmButton?.setAttribute("disabled", "true");
        return;
      }
      confirmButton?.removeAttribute("disabled");
    });
    if (confirmButton) {
      confirmButton.addEventListener("click", async function (event) {
        event.preventDefault();
        const selected = select_by_vehicle.selectedOptions[0];
        if (!selected?.dataset.relativeModel || select_by_make.value === 'MAKE' || select_by_model.value === 'MODEL' || select_by_vehicle.value === 'VEHICLE') return;
        confirmButton.classList.add("loading");
        confirmButton.setAttribute("disabled", "true");
        const vehicle = {
          vehicleName: select_by_vehicle.value,
          vehicleFilter: encodeURI(select_by_vehicle.value),
          vehicleModel: selected.dataset.relativeModel,
          vehicleMake: select_by_make.value,
          vehicleImage: selected.dataset.vehicleImage,
          vehicleCollectionHandle: selected.dataset.vehicleCollectionHandle || "",
          vehicleTitleOverwrite: selected.dataset.vehicleTitleOverwrite || "",
        };
        try {
          const isHome = window.Shopify?.globalVehicleFilter?.page_type === 'index' || location.pathname === (window.Shopify?.routes?.root || '/');
          await window.globalVehicleFilter.setFilter(vehicle, !isHome);
          if (isHome) {
            const current = new URL(location.href);
            current.searchParams.set('filter.p.m.organizer.car_models', vehicle.vehicleName);
            history.replaceState(history.state, '', current);
            window.globalVehicleFilter.applyFilter(vehicle);
            document.dispatchEvent(new CustomEvent('njt:vehicle-state', { detail: vehicle }));
            return;
          }
          if (vehicle.vehicleCollectionHandle && window.Shopify?.globalVehicleFilter?.vehicle_page) {
            const url = new URL(`/collections/${vehicle.vehicleCollectionHandle}`, location.origin);
            const current = new URL(location.href);
            for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
            window.location.href = url;
          }
        } catch (e) {
          console.error('Vehicle selection could not be applied', e);
        } finally {
          confirmButton.classList.remove('loading');
          confirmButton.removeAttribute('disabled');
        }
      });
    }

    const closeButton = document.querySelector(
      ".section-vehicle-filter--wrapper .close-button"
    );
    if (closeButton) {
      closeButton.addEventListener("click", function () {
        wrapper.classList.add("closed");
      });
    }
    const selectedVehicleBox = document.querySelector(
      ".current-vehicle-filter .select__box"
    );
    if (selectedVehicleBox) {
      selectedVehicleBox.addEventListener("click", function () {
        wrapper.classList.toggle("closed");
      });
    }
    const clearSelectionButton = document.querySelector(
      ".current-vehicle-filter .change-vehicle-filter"
    );
    if (clearSelectionButton) {
      clearSelectionButton.addEventListener("click", function () {
        wrapper.classList.toggle("closed");
        window.globalVehicleFilter.clearFilter();
      });
    }
  }
  window.addEventListener("DOMContentLoaded", init);
})();
